import React, { Component } from "react";
import PropTypes from "prop-types";

class Captions extends Component {
    static propTypes = {
        line1: PropTypes.string,
        line2: PropTypes.string
    };

    render() {
        const { line1, line2 } = this.props;

        if (!line1 && !line2) {
            return null;
        }

        return (
            <>
                {line1 && <div className="captions__line1">{line1}</div>}
                {line2 && <div className="captions__line2">{line2}</div>}
            </>
        );
    }
}

export default Captions;



// WEBPACK FOOTER //
// ./src/scripts/components/Captions.js